import {
    LOGIN_SUCCESS,
    LOGIN_ERROR,
    SUBMIT_LOGIN,
    LOGOUT
} from '../actionTypes'

import {
    getInfoLocalStorage,
    setInfoLocalStorage,
    destroyInfoLocalStorage
} from '../../utils/api'

const stateFromLocalStorage = getInfoLocalStorage()

const initialState = {
    logged: stateFromLocalStorage.logged || false,
    userid: stateFromLocalStorage.userid || 0,
    tipoUser: stateFromLocalStorage.tipoUser || 0,
    logMessage: '',
    isLoading: false,
    nome: stateFromLocalStorage.nome || ''
}

export default (state = initialState, action) => {
    switch(action.type) {
        case SUBMIT_LOGIN:
            if (!state.logged) {
                return {
                    ...state,
                    isLoading: true
                }
            }
            return state

        case LOGIN_SUCCESS:
            const userInfo = {
                logged: true,
                userid: action.payload.id | 0,
                tipoUser: action.payload.tipo | 0,
                token: action.payload.token || '',
                nome: action.payload.nome || ''
            }
            setInfoLocalStorage(userInfo)
            return {
                ...state,
                logMessage: '',
                isLoading: false,
                ...userInfo
            }

        case LOGIN_ERROR:
            if (!state.logged) {
                return {
                    ...state,
                    logMessage: action.payload.message,
                    isLoading: false
                }
            }
            return state

        case LOGOUT:
            if (state.logged) {
                destroyInfoLocalStorage()
                return {
                    logged: false,
                    userid: 0,
                    tipoUser: 0
                }
            }
            return state

        default:
            return state
    }
}